import { createStore } from "@methodjs/store";

const initLoadingState = () => false;

const [useLoadingStore, setLoadingStore, getLoadingStore] =
  createStore(initLoadingState);

export { useLoadingStore, setLoadingStore, getLoadingStore };
